// RemoteWorkingAndLeave
export const DISPLAY_TYPES = {
  LIST: 'list',
  PLANNING: 'planning',
};
/**
 * @type {{
 * REMOTE_WORKING: 'RemoteWorking',
 * LEAVE: 'Leave'
 * }}
 */
export const VIEW_DOMAIN = {
  REMOTE_WORKING: 'RemoteWorking',
  LEAVE: 'Leave',
};

export const REMOTE_WORKING_PLACES = {
  HOME: 'home',
  OTHER: 'other',
};

export const BU_ZOL = 'ZOL';
export const BU_QWERI = 'QWERI';
export const BU_BANZAI = 'BANZAI';
export const BUSINESS_UNITS = {
  [BU_ZOL]: BU_ZOL,
  [BU_QWERI]: BU_QWERI,
  [BU_BANZAI]: BU_BANZAI,
};
